<script setup lang="ts">
import { mergeProps } from 'vue'
import { storeToRefs } from 'pinia'
import { useCoreStore } from '@/modules/core/store'
import { Skolear } from '@/modules/core/models/types'
import { useI18n } from 'vue-i18n'

const { skolear } = storeToRefs(useCoreStore())

const { t } = useI18n()

const modelValue = defineModel<Skolear>()

withDefaults(
  defineProps<{
    showLabel?: boolean
  }>(),
  {
    showLabel: true
  }
)
</script>

<template>
  <v-menu v-if="!showLabel">
    <template #activator="{ props: menuProps }">
      <v-tooltip
        :disabled="$vuetify.display.lgAndUp"
        :text="t('meny.velg_skolear', 'Velg skoleår')"
        location="bottom"
      >
        <template #activator="{ props: tooltipProps }">
          <v-btn
            v-bind="mergeProps(menuProps, tooltipProps)"
            variant="text"
            class="text-capitalize"
            :size="$vuetify.display.lgAndUp ? 'default' : 'small'"
            :aria-label="t('meny.velg_skolear', 'Velg skoleår')"
          >
            <span>{{ modelValue?.navn }}</span>
            <template #append>
              <v-icon icon="mdi-menu-down" />
            </template>
          </v-btn>
        </template>
      </v-tooltip>
    </template>
    <v-list density="compact">
      <v-list-item
        v-for="item in skolear"
        :key="item.id"
        :active="modelValue?.id === item.id"
        color="primary"
        @click="modelValue = item"
      >
        <v-list-item-title>{{ item.navn }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-select
    v-else
    v-model="modelValue"
    :variant="'outlined'"
    :density="'comfortable'"
    color="primary"
    item-color="primary"
    :menu-props="{ scrim: true, scrollStrategy: 'close' }"
    :items="skolear"
    item-value="id"
    item-title="navn"
    return-object
    class="text-capitalize"
  >
    <template #label>
      <span>{{ t('core.skolear', 'Velg skoleår') }}</span>
    </template>
  </v-select>
</template>
